var bodyScrollBar, isLoaded = !1;

var trigger_desktop_animations = function() {

    gsap.from('.path-img1 img', {
        scrollTrigger: {
            scroller: "#about-main-content",
            trigger: '.path-img1 img',
            end: "60% 50%",
            scrub: 1,
            horizontal: !0,
            onEnter: function() {
                gsap.to('.founder-content.box-1', 1, {
                    opacity: 1,
                    ease: Power1.easeInOut
                })
            }
        },
        x: -100,
        ease: "sine.out",
    })
    gsap.from('.path-img5 img', {
        scrollTrigger: {
            scroller: "#about-main-content",
            trigger: '.path-img5 img',
            end: "60% 50%",
            scrub: 1,
            horizontal: !0,
            onEnter: function() {
                gsap.to('.path-img5', 1, {
                    opacity: 1,
                    ease: Power1.easeInOut
                })
            }
        },
        x: -100,
        ease: "sine.out",
    })
    gsap.from('.desktop-only .img-box-2 img', {
        scrollTrigger: {
            scroller: "#about-main-content",
            trigger: '.desktop-only .img-box-2 img',
            end: "60% 50%",
            scrub: 1,
            horizontal: !0,
            onEnter: function() {
                gsap.to('.desktop-only .img-box-2', 1, {
                    opacity: 1,
                    ease: Power1.easeInOut
                })
            }
        },
        x: -100,
        ease: "sine.out",
    })
    gsap.from('.path-img4-new img', {
        scrollTrigger: {
            scroller: "#about-main-content",
            trigger: '.path-img4-new img',
            end: "60% 50%",
            scrub: 1,
            horizontal: !0,
            onEnter: function() {
                gsap.to('.path-img4-new', 1, {
                    opacity: 1,
                    ease: Power1.easeInOut
                })
            }
        },
        x: -100,
        ease: "sine.out",
    })
    gsap.from('.path-img6', {
        scrollTrigger: {
            scroller: "#about-main-content",
            trigger: '.path-img6',
            end: "60% 50%",
            scrub: 1,
            horizontal: !0,
            onEnter: function() {
                gsap.to('.desktop-only .box-3-content-btm', 1, {
                    opacity: 1,
                    ease: Power1.easeInOut
                })
            }
        },
        x: -100,
        ease: "sine.out",
    })
    gsap.from('.path-img4', {
        scrollTrigger: {
            scroller: "#about-main-content",
            trigger: '.path-img4',
            end: "60% 50%",
            scrub: 1,
            horizontal: !0,
            onEnter: function() {
                gsap.to('.desktop-only .content-2', 1, {
                    opacity: 1,
                    ease: Power1.easeInOut
                })
            }
        },
        x: -100,
        ease: "sine.out",
    })

    gsap.from('.tm-mission-left', {
        scrollTrigger: {
            scroller: "#about-main-content",
            trigger: '.tm-mission-left',
            end: "60% 50%",
            scrub: 1,
            horizontal: !0,
            onEnter: function() {
                gsap.to('.tm-misson-content', 1, {
                    opacity: 1,
                    ease: Power1.easeInOut
                })
            }
        },
        y: -100,
        ease: "sine.out",
    })
    gsap.from('.tm-mission-right', {
        scrollTrigger: {
            scroller: "#about-main-content",
            trigger: '.tm-mission-right',
            end: "60% 50%",
            scrub: 1,
            horizontal: !0,
            onEnter: function() {
                gsap.to('.tm-mission-left', 1, {
                    opacity: 1,
                    ease: Power1.easeInOut
                })
            }
        },
        y: 100,
        ease: "sine.out",
    })


    var e = document.querySelectorAll(".about-timeline li.time-line-date");

    gsap.utils.toArray(e).forEach(function(etl, t) {
        var tl_year = etl.querySelector("h1");
        gsap.from(tl_year, {
            scrollTrigger: {
                scroller: "#about-main-content",
                trigger: tl_year,
                end: "60% 50%",
                scrub: 1,
                horizontal: !0,
                onEnter: function() {
                    gsap.to(etl, .6, {
                        opacity: 1,
                        ease: Power1.easeInOut
                    })
                }
            },
            opacity: 0,
            ease: "sine.out",
        })
    });

    timeline_img = document.querySelectorAll(".about-timeline li.li-top .timeline-content img");
    gsap.utils.toArray(timeline_img).forEach(function(e, t) {
        r = e.closest("div")
        gsap.from(e, {
            scrollTrigger: {
                scroller: "#about-main-content",
                trigger: e,
                end: "60% 50%",
                scrub: 1,
                horizontal: !0,
                onEnter: function() {
                    gsap.to(r, .6, {
                        opacity: 1,
                        ease: Power1.easeInOut
                    })
                }
            },
            opacity: 0,
            ease: "sine.out",
            y: -100
        })
    });
    timeline_img = document.querySelectorAll(".about-timeline li.li-btm .timeline-content img");
    gsap.utils.toArray(timeline_img).forEach(function(e, t) {
        r = e.closest("div")
        gsap.from(e, {
            scrollTrigger: {
                scroller: "#about-main-content",
                trigger: e,
                end: "60% 50%",
                scrub: 1,
                horizontal: !0,
                onEnter: function() {
                    gsap.to(r, .6, {
                        opacity: 1,
                        ease: Power1.easeInOut
                    })
                }
            },
            opacity: 0,
            ease: "sine.out",
            y: 100
        })
    });
    timeline_img = document.querySelectorAll(".about-timeline li.li-top .timeline-content .timeline_description");
    gsap.utils.toArray(timeline_img).forEach(function(e, t) {
        var des = e.querySelector("span");
        gsap.from(des, {
            scrollTrigger: {
                scroller: "#about-main-content",
                trigger: des,
                end: "60% 50%",
                scrub: 1,
                horizontal: !0,
                onEnter: function() {
                    gsap.to(e, .6, {
                        opacity: 1,
                        ease: Power1.easeInOut
                    })
                }
            },
            opacity: 0,
            ease: "sine.out",
            y: -100
        })
    });
    timeline_img = document.querySelectorAll(".about-timeline li.li-btm .timeline-content .timeline_description");
    gsap.utils.toArray(timeline_img).forEach(function(e, t) {
        var des = e.querySelector("span");
        gsap.from(des, {
            scrollTrigger: {
                scroller: "#about-main-content",
                trigger: des,
                end: "60% 50%",
                scrub: 1,
                horizontal: !0,
                onEnter: function() {
                    gsap.to(e, .6, {
                        opacity: 1,
                        ease: Power1.easeInOut
                    })
                }
            },
            opacity: 0,
            ease: "sine.out",
            y: 100
        })
    });
}

function _inheritsLoose(e, t) {
    e.prototype = Object.create(t.prototype), (e.prototype.constructor = e).__proto__ = t
}

function reload_plugin() {
    Scrollbar.destroyAll();
    var e, t, r, o = function(e) {
        function t() {
            return e.apply(this, arguments) || this
        }
        return _inheritsLoose(t, e), t.prototype.transformDelta = function(e, t) {
            if (!/wheel/.test(t.type)) return e;
            t = e.x, e = e.y;
            return {
                y: 0,
                x: Math.abs(t) > Math.abs(e) ? t : e
            }
        }, t
    }(Scrollbar.ScrollbarPlugin);
    r = "horizontalScroll", (t = "pluginName") in (e = o) ? Object.defineProperty(e, t, {
        value: r,
        enumerable: !0,
        configurable: !0,
        writable: !0
    }) : e[t] = r, Scrollbar.use(o)
}

function make_scrollProxy(e, t) {
    reload_plugin();
    (bodyScrollBar = Scrollbar.init(e, {
        damping: .1,
        delegateTo: document,
        overscrollEffect: "bounce",
        alwaysShowTracks: !0
    })).update(), bodyScrollBar.addListener(function(e) {
        e = e.offset;
        e.x, e.y
        onScrollDesktop(e.x);
    }), bodyScrollBar.setPosition(0, 0), bodyScrollBar.track.yAxis.element.remove(), ScrollTrigger.scrollerProxy(e, {
        scrollLeft: function(e) {
            return arguments.length && (bodyScrollBar.scrollLeft = e, bodyScrollBar.addMovement(e, 0)), rotate_num = bodyScrollBar.scrollLeft, bodyScrollBar.scrollLeft
        }
    }), isLoaded = !1, bodyScrollBar.addListener(trigger_init), setTimeout(function() {
        num = bodyScrollBar.getSize().content.width, window.addEventListener("keydown", function(e) {
            ieKeyDown(e.keyCode)
        })
    }, 200), bodyScrollBar.addListener(ScrollTrigger.update)
}

function ieKeyDown(e) {
    37 == e ? bodyScrollBar.scrollLeft -= 60 : 39 == e && (bodyScrollBar.scrollLeft += 60)
}

function trigger_init() {
    isLoaded || (isLoaded = !0, setTimeout(function() {
        trigger_desktop_animations()
    }, 100))
}


$(document).ready(function() {


    var winwidth = $(window).width();

    if (winwidth > 1024) {
        make_scrollProxy(document.querySelector("#about-main-content"));
		$(document).on("scroll touchmove", onScrollDesktop);
        $('.value-slider').slick({
            infinite: true,
            slidesToShow: 1,
            slidesToScroll: 1,
            arrows: true,
            dots: true,
            vertical: true
        });


        var timeline = 0;
        $('.about-timeline ol li').each(function() {
            var nextLI = $(this).outerWidth();
            timeline = timeline + nextLI;
        });
        timeline = timeline + 1290;
        $('#shopify-section-about-menu li').on('click', function() {
            if (!$(this).hasClass('active')) {
                $('#shopify-section-about-menu li.active').removeClass('active');
                $(this).addClass('active');
                var elem = $(this).data('target');
                var active = $('#' + elem);
                var left = $(active)[0].offsetLeft;
                gsap.to(bodyScrollBar, 1.4, {
                    scrollTo: {
                        x: left - 140
                    }
                })
            }
        })
        $('#shopify-section-about-our-story .read-more').on('click', function() {
          var left = $('#shopify-section-about-our-founder')[0].offsetLeft;
            gsap.to(bodyScrollBar, 1.4, {
                scrollTo: {
                    x: left - 140
                }
            })
        })
        $('#timeline_to_start').on('click', function() {
            gsap.to(bodyScrollBar, 1.4, {
                scrollTo: {
                    x: 0
                }
            })
        })

    } else {
        gsap.registerPlugin(ScrollTrigger);

        gsap.from(".tm-mission-left", {
            scrollTrigger: {
                trigger: ".tm-misson-content",
                scrub: true
            },
            x: -100,
            ease: "sine.out",
            opacity: 0
        });
        gsap.from(".tm-mission-right", {
            scrollTrigger: {
                trigger: ".tm-mission-left",
                scrub: true
            },
            x: 100,
            ease: "sine.out",
            opacity: 0
        });

        gsap.from(".founder_sec_img1", {
            scrollTrigger: {
                trigger: ".founder-content.box-1",
                scrub: true
            },
            x: 100,
            ease: "sine.out",
            opacity: 0
        });
        gsap.from(".founder_sec_img2", {
            scrollTrigger: {
                trigger: ".founder-content.box-1",
                scrub: true
            },
            x: -100,
            ease: "sine.out",
            opacity: 0
        });
        gsap.from(".founder_sec_img3", {
            scrollTrigger: {
                trigger: ".founder-content.box-3-content-btm",
                scrub: true
            },
            x: 100,
            ease: "sine.out",
            opacity: 0
        });
        gsap.from(".founder_sec_img4", {
            scrollTrigger: {
                trigger: ".founder-content.box-3-content-btm",
                scrub: true
            },
            x: -100,
            ease: "sine.out",
            opacity: 0
        });

        e = document.querySelectorAll(".about-timeline li.time-line-date");
        gsap.utils.toArray(e).forEach(function(e, t) {

            var tl_year = e.querySelector("h1");
            gsap.from(tl_year, {
                scrollTrigger: {
                    trigger: e,
                    scrub: true,
                    end: "60% 50%"
                },
                x: -100,
                ease: "sine.out",
                opacity: 0
            });
        });
        timeline_img = document.querySelectorAll(".about-timeline li .timeline-content img");
        gsap.utils.toArray(timeline_img).forEach(function(e, t) {

            gsap.from(e, {
                scrollTrigger: {
                    trigger: e,
                    scrub: true,
                    end: "60% 50%"
                },
                x: 100,
                ease: "sine.out",
                opacity: 0
            });
        });
        timeline_text = document.querySelectorAll(".about-timeline li .timeline-content .timeline_description span");
        gsap.utils.toArray(timeline_text).forEach(function(e, t) {

            gsap.from(e, {
                scrollTrigger: {
                    trigger: e,
                    scrub: true,
                    end: "60% 50%"
                },
                x: 100,
                ease: "sine.out",
                opacity: 0
            });
        });

        $(document).on("scroll touchmove", onScroll);
        $('.value-slider').slick({
            infinite: true,
            slidesToShow: 1,
            slidesToScroll: 1,
            arrows: true,
            dots: true,
            vertical: false
        });
        $('#shopify-section-about-menu li').on('click', function() {
            if (!$(this).hasClass('active')) {
                $('#shopify-section-about-menu li.active').removeClass('active');
                $(this).addClass('active');
                var elem = $(this).data('target');
                var active = $('#about-main-content').find('#' + elem);
                var pos = active.offset().top;
                $('body').animate({
                    scrollTop: pos - 70
                }, 2000);
            }
        })
        $('#shopify-section-about-our-story .read-more').on('click', function() {
            $('body').animate({
                scrollTop: $('#shopify-section-about-our-founder').offset().top - 70
            }, 2000);
        })
        $('#timeline_to_start').on('click', function() {
            $('body').animate({
                scrollTop: $('#shopify-section-about-our-story').offset().top
            }, 2000);
        })
    }

});

function onScroll(e) {
    var scrollPos = $(this).scrollTop();
    $('.about-menu li').each(function() {
        var currLink = $(this);
        var refElement = $('#' + currLink.attr("data-target"));
        if (refElement.position().top <= scrollPos) {
            $('.about-menu li').removeClass("active");
            currLink.addClass("active");
        } else {
            currLink.removeClass("active");
        }
    });
}

function onScrollDesktop(scrollPos) {
    $('.about-menu li').each(function() {
        var currLink = $(this);
        var refElement = $('#' + currLink.attr("data-target"));
        if ($(refElement)[0].offsetLeft <= scrollPos) {
            $('.about-menu li').removeClass("active");
            currLink.addClass("active");
        }
    });
}

function setMenuTargetMeasurement(isDesktop) {
    if (isDesktop) {
        $('#shopify-section-about-our-story').attr('data-measure', $('#shopify-section-about-our-story').width() + $('#shopify-section-about-our-founder').width());
        $('#shopify-section-about-mission').attr('data-measure', $('#shopify-section-about-mission').width());
        $('#shopify-section-about-our-values').attr('data-measure', $('#shopify-section-about-our-values').width());
        $('#shopify-section-about-follow-our').attr('data-measure', $('#shopify-section-about-follow-our').width());
    } else {
        $('#shopify-section-about-our-story').attr('data-measure', $('#shopify-section-about-our-story').height() + $('#shopify-section-about-our-founder').height());
        $('#shopify-section-about-mission').attr('data-measure', $('#shopify-section-about-mission').height());
        $('#shopify-section-about-our-values').attr('data-measure', $('#shopify-section-about-our-values').height());
        $('#shopify-section-about-follow-our').attr('data-measure', $('#shopify-section-about-follow-our').height());
    }
}
// $(document).ready(function(){
//     if(window.matchMedia("(max-width: 1024px)").matches){
//         $('.scroll-content').css('transform', 'translate3d(0px, 0px, 0px)');
//     } else{
//         alert("This is a tablet or desktop.");
//     }
// });